<template>
    <modal @close="closeModal">

        <div>
            <div class="u-margin-bottom">
                {{
                    trans('hosting.settings.reset-passwords-explanation', {
                        username: this.username
                    })
                }}
            </div>
        </div>

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.settings.reset-passwords-username') }}
                    </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        {{ username }}
                    </div>
                </div>
            </div>
        </div>

        <div class="page-block__item u-margin-bottom">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.settings.reset-passwords-password') }}
                    </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        {{ password ? password : '---' }}
                    </div>
                    <!-- TODO:: copy paste knopje erbij! -->
                </div>
            </div>
        </div>

        <div class="modal__nav">

            <button
                @click="resetPassword()"
                type="button"
                class="btn btn--ghost btn--ghost-full-width"
            >
                {{ trans('hosting.settings.reset-passwords-action') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { Modal } from 'relapp-modal';
import { apiMixin } from 'relapp-api';
import HostingApi from '../services/api/hosting.js';
import {EventBus} from "relapp-event/src/event";

export default {
    components: {
        Modal
    },
    mixins: [apiMixin],
    props: {
        domain: {
            type: String,
            required: true
        },
        username: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            password: this.$parent.password
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        resetPassword() {
            HostingApi.resetPassword(this.domain)
                .then(response => {
                    this.username = response.data.username;
                    this.password = response.data.password;
                    this.$parent.password = response.data.password;
                })
                .catch(function (result) {
                    if (result.data.message === "IntegratedService does not support resetting passwords yet!") {
                        EventBus.$emit('notification', {
                            type: 'error',
                            message: result.data.message
                        });
                    }
                });
        }
    }
};
</script>
